module.exports = __webpack_public_path__ + "img/3.662d8828.jpg";